var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center",staticStyle:{"height":"100vh"}},[_c('i',{staticClass:"fa fa-cog fa-spin fa-2x text-muted"})])
}]

export { render, staticRenderFns }